import styled from 'styled-components'

import { mainColors, semanticColors } from '../../styles/colors'
import { _S_Normal } from '../../styles/typography'
import { TooltipTheme } from './Tooltip'

export const Container = styled.div<{
  $theme: TooltipTheme
  $maxWidth?: number | string
  $animation?: boolean
}>`
  ${_S_Normal};
  position: relative;
  background-color: ${mainColors.white};
  color: ${mainColors.black};
  border: 1px solid ${mainColors.neutralLight};
  border-radius: 2px;
  padding: 6px 8px;
  max-width: ${({ $maxWidth }) =>
    $maxWidth !== undefined
      ? typeof $maxWidth === 'number'
        ? `${$maxWidth}px`
        : $maxWidth
      : '320px'};
  word-break: break-word;
  white-space: pre-wrap;
  ${({ $theme }) =>
    $theme !== TooltipTheme.dark ? 'box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.1)' : ''};

  ${({ $animation }) =>
    $animation !== false &&
    `
    animation: floatingTooltipFadeIn 150ms ease-out;

    @keyframes floatingTooltipFadeIn {
      from {
        opacity: 0;
        transform: scale(0.96);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
  `}

  ${({ $theme }) =>
    $theme === TooltipTheme.dark &&
    `
      background-color: ${mainColors.primaryMedium};
      border-color: ${mainColors.primaryMedium};
      color: ${mainColors.white};
    `}
  ${({ $theme }) =>
    $theme === TooltipTheme.light &&
    `
      background-color: ${mainColors.white};
      border-color: ${mainColors.neutralLight};
      color: ${mainColors.black};
    `}
  ${({ $theme }) =>
    $theme === TooltipTheme.danger &&
    `
      background-color: ${semanticColors.failureExtraLight};
      border-color: ${semanticColors.failureExtraLight};
      color: ${semanticColors.failureMedium};
    `}
  ${({ $theme }) =>
    $theme === TooltipTheme.alert &&
    `
      background-color: ${semanticColors.warningExtraLight};
      border-color: ${semanticColors.warningExtraLight};
      color: ${semanticColors.warningDark};
    `}
`
